import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

type UseDeleteSalesDepositArgs = { onSuccess?: () => void }

export const useDeleteSalesDepositConfirmation = ({ onSuccess }: UseDeleteSalesDepositArgs) => {
  const router = useRouter()
  const [sdForDelete, setSdForDelete] = useState<number | null>(null)

  const { mutate: deleteSalesDeposit } = useMutation<void, Error, { id: number }>({
    mutationFn: ({ id }) => Request.delete(Request.urls.bank.annualReviewSalesDeposits, { id }),
    onSuccess: async () => {
      Toast.successSmall(`Sales Deposit was successfully deleted.`)
      if (onSuccess) onSuccess()
      else router.invalidate()
    },
    onError: (error) => handlerServerError(error)
  })

  const { Confirmation, open } = useConfirmation({
    message: (
      <span>
        Are you sure you want to delete <i>SDS-{sdForDelete}</i> Sales and Deposit table?
      </span>
    ),
    onConfirm: () => {
      if (sdForDelete) deleteSalesDeposit({ id: sdForDelete })
    },
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true,
    onCancel: () => setSdForDelete(null)
  })

  const openDeleteSalesDepositConfirmation = (id: number) => {
    setSdForDelete(id)
    open()
  }

  return { DeleteConfirmation: Confirmation, openDeleteSalesDepositConfirmation }
}
